<script setup lang="ts">
import { onMounted, ref } from 'vue'
import ChatMessage from './ChatMessage.vue'
import ChatTextArea from './ChatTextArea.vue'
import { cn } from '@/lib/utils'
import { useChatStore } from '@/stores/useChat'

const { api, clientId, pendingQuestion } = defineProps<{
  api?: string
  clientId?: string
  pendingQuestion?: string
}>()

const emit = defineEmits<{
  questionSent: []
}>()

const chatEl = ref<HTMLDivElement>()
const extraBottomSpace = ref(0)
const chatStore = useChatStore()

onMounted(async () => {
  // Load messages from server when component mounts
  if (api && clientId) {
    await chatStore.loadMessages(api, clientId)
  }

  window.addEventListener('message', (e) => {
    const { data } = e
    if (data.isForChat && data.messageSent)
      chatEl.value?.scrollTo(0, chatEl.value.scrollHeight)
  })
})
</script>

<template>
  <div :class="cn('conversation-wrapper', $attrs.class ?? '')">
    <div class="conversation-container">
      <div
        class="netwatch-conversation netwatch-container-animated"
        tabindex="-1" role="presentation"
      >
        <div class="netwatch-conversation-body netwatch-conversation-flex">
          <div
            ref="chatEl"
            class="netwatch-conversation-body-parts"
            aria-live="assertive"
            tabindex="0" aria-atomic="false"
            role="alert" :style="`bottom: ${extraBottomSpace + 56}px;`"
          >
            <div class="netwatch-conversation-body-main-group">
              <div class="chats-view-wrapper">
                <div
                  class="chats-view chat-enter"
                  style="transform: translateY(0px);"
                >
                  <div v-for="message, idx in chatStore.responses" :key="idx">
                    <!-- chats -->
                    <ChatMessage v-bind="message" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Chat Text Area -->
        <ChatTextArea
          v-model="extraBottomSpace"
          :api="api"
          :client-id="clientId"
          :pending-question="pendingQuestion"
          @question-sent="emit('questionSent')"
        />
        <!-- Chat Text area end -->
      </div>
    </div>
  </div>
</template>
